export default __webpack_public_path__ + "static/img2-bf327d3f8b4bab214734285d4e72f78f.jpg";